const Features = () => {
  return (
    <section id='features' className='bg-secondary py-10'>
      <div className='container flex flex-col px-4 mx-auto mt-10 space-y-12 md:space-y-0 md:flex-row'>
        <div className='flex flex-col space-y-8 md:w-1/2'>
          <h2 className='max-w-md text-4xl font text-center md:text-left text-textGray font-roboto'>
            Novo regime fiscal: precisão e transparência
          </h2>
          <p className='max-w-sm text-center text-darkGrayishBlue md:text-left'>
            Com a chegada do novo regime fiscal, o sistema tributário brasileiro passa por uma transformação profunda —
            com novas regras, códigos (IBS e CBS) e critérios de classificação que exigem
            atenção redobrada. Em um cenário de atualizações constantes e alta exigência regulatória, a precisão e a transparência no
            cumprimento das obrigações fiscais tornam-se fatores essenciais para a sustentabilidade e a competitividade da sua empresa.
          </p>
        </div>
        <div className='flex flex-col space-y-8 md:w-1/2'>
          <div className='flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row'>
            <div className='rounded-l-full bg-brightRedSupLight md:bg-transparent'>
              <div className='flex items-center space-x-2'>
                <div className='px-4 py-2 text-white rounded-full md:py-1 bg-brightRed'>
                  01
                </div>
                <h3 className='text-base font-semibold text-textGray md:mb-4 md:hidden'>
                  Agilidade e produtividade
                </h3>
              </div>
            </div>
            <div>
              <h3 className='hidden mb-4 text-lg font-semibold text-textGray md:block'>
                Agilidade e produtividade
              </h3>
              <p className='text-darkGrayishBlue'>
                Acesse dados fiscais atualizados instantaneamente, otimizando o tempo da sua equipe e permitindo foco em atividades estratégicas.
              </p>
            </div>
          </div>
          <div className='flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row'>
            <div className='rounded-l-full bg-brightRedSupLight md:bg-transparent'>
              <div className='flex items-center space-x-2'>
                <div className='px-4 py-2 text-white rounded-full md:py-1 bg-brightRed'>
                  02
                </div>
                <h3 className='text-base font-semibold text-textGray md:mb-4 md:hidden'>
                  Segurança jurídica e conformidade total.
                </h3>
              </div>
            </div>
            <div>
              <h3 className='hidden mb-4 text-lg font-semibold text-textGray md:block'>
                Segurança jurídica e conformidade total
              </h3>
              <p className='text-darkGrayishBlue'>
                Reduza drasticamente o risco de erros, multas e autuações. O AudProopera com base nas últimas Notas Técnicas, tabelas oficiais e na Lei Complementar da Reforma Tributária.
              </p>
            </div>
          </div>
          <div className='flex flex-col space-y-3 md:space-y-0 md:space-x-6 md:flex-row'>
            <div className='rounded-l-full bg-brightRedSupLight md:bg-transparent'>
              <div className='flex items-center space-x-2'>
                <div className='px-4 py-2 text-white rounded-full md:py-1 bg-brightRed'>
                  03
                </div>
                <h3 className='text-base font-semibold text-textGray md:mb-4 md:hidden'>
                  Clareza e autonomia
                </h3>
              </div>
            </div>

            <div>
              <h3 className='hidden mb-4 text-lg font-semibold text-textGray md:block'>
                Clareza e autonomia
              </h3>
              <p className='text-darkGrayishBlue'>
                Elimine a dependência de consultas manuais e interpretações complexas. Nossa plataforma traduz a legislação em informações objetivas e acionáveis.

              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
